/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonIdFinancialDataQueryResponse,
  GetApiV1PersonIdFinancialDataPathParams,
  GetApiV1PersonIdFinancialData401,
  GetApiV1PersonIdFinancialData404,
  GetApiV1PersonIdFinancialData500,
} from "../../types/personFinancialController/GetApiV1PersonIdFinancialData.ts";

function getGetApiV1PersonIdFinancialDataUrl(
  id: GetApiV1PersonIdFinancialDataPathParams["id"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/person/${id}/financial-data` as const,
  };
  return res;
}

/**
 * @description Retorna os dados da aba Financial da pessoa (banco, agência, contas, método de pagamento e tipo de conta). Inclui descrição textual dos enums (PaymentMethodName e AccountTypeName). **(Requer Authorization para autenticação)**
 * @summary Obter dados financeiros (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/financial-data}
 */
export async function getApiV1PersonIdFinancialData(
  id: GetApiV1PersonIdFinancialDataPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonIdFinancialDataQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonIdFinancialData401
      | GetApiV1PersonIdFinancialData404
      | GetApiV1PersonIdFinancialData500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonIdFinancialDataUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
